import { validityChecker } from './ApiFunctions';
import { PROVIDER_LABELS_MAP } from '../constants';

/**
 * Function to consolidate all provider specialties based on providerLocAndPractRole data recieved from PES.
 * returned data is displayed on estimates page under provider name.
 * @param {Array} providerLocAndPractRole list of all Location and practioner speciality data recieved for the provider from PES.
 */
export const allProviderSpecialties = (providerLocAndPractRole) => {
    let allSpecialties = new Set();

    providerLocAndPractRole?.map((locAndPractRole) => {
        locAndPractRole?.specialties?.map((speciality) => {
            allSpecialties.add(speciality);
        });
    });

    return [...allSpecialties];
};

/**
 * TODO finish documenting
 * Used for the sorting and eventual rendering of providers
 * @param {*} data
 * @returns
 */
export const mapProviders = (data) => {
    const locAndPractData = data.filter((x) => x.locAndPractRole);
    const resp = locAndPractData.map((x) => {
        x.locAndPractRole = Object.values(x.locAndPractRole);
        if (x?.type?.toLowerCase() == 'place') {
            return {
                label: PROVIDER_LABELS_MAP?.[x?.type?.toLowerCase()],
                unTranslatedText: validityChecker(x?.name),
                ...x,
            };
        }
        return {
            label: PROVIDER_LABELS_MAP?.[x?.type?.toLowerCase()],
            unTranslatedText: [
                validityChecker(x?.name?.last),
                validityChecker(x?.name?.first),
                validityChecker(x?.name?.degree),
            ].join(', '),
            ...x,
        };
    });
    return resp.filter((x) => x.label);
};
